<template>
  <div class="channel-stats-card">
    <div class="bg-light rounded p-3">
      <div class="mb-2">
        <small class="text-muted fw-medium">
          <i class="fas fa-chart-bar me-1"></i>
          Статистика
        </small>
      </div>
        
      <!-- Загрузка -->
      <div v-if="loading" class="text-center">
        <small class="text-muted">
          <div class="spinner-border spinner-border-sm me-1" role="status"></div>
          Загрузка...
        </small>
      </div>

      <!-- Ошибка -->
      <div v-else-if="error" class="text-muted small">
        <i class="fas fa-exclamation-triangle me-1"></i>
        Ошибка
      </div>

      <!-- Статистика -->
      <div v-else-if="stats" class="stats-content">
        <!-- Мини прогресс -->
        <div class="d-flex align-items-center mb-2">
          <div class="progress flex-grow-1 me-2" style="height: 4px;">
            <div 
              class="progress-bar bg-secondary" 
              :style="{ width: (stats.progress || 0) + '%' }">
            </div>
          </div>
          <small class="text-muted text-nowrap">
            {{ Math.round(stats.progress || 0) }}%
          </small>
        </div>

        <!-- Вертикальный список статистики -->
        <div class="stats-list">
          <div class="d-flex justify-content-between align-items-center py-1">
            <small class="text-muted">Всего:</small>
            <small class="fw-bold">{{ stats.total?.count || 0 }} <span class="text-muted">({{ stats.total?.duration_hours || '0 ч' }})</span></small>
          </div>
          <div class="d-flex justify-content-between align-items-center py-1">
            <small class="text-muted">Готово:</small>
            <small class="fw-bold">{{ stats.processed?.count || 0 }} <span class="text-muted">({{ stats.processed?.duration_hours || '0 ч' }})</span></small>
          </div>
          <div class="d-flex justify-content-between align-items-center py-1">
            <small class="text-muted">Очередь:</small>
            <small class="fw-bold">{{ stats.draft?.count || 0 }} <span class="text-muted">({{ stats.draft?.duration_hours || '0 ч' }})</span></small>
          </div>
          <div v-if="showPricing" class="d-flex justify-content-between align-items-center py-1 border-top pt-2 mt-1">
            <small class="text-muted">Стоимость:</small>
            <small class="fw-bold">{{ stats.draft?.sum || '0 ₽' }}</small>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axiosConfig from "@/lib/axiosConfig";
import { API_URL } from "@/config.js";
import { mapGetters } from 'vuex';

export default {
  name: "ChannelStatsComponent",
  props: {
    channelId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      stats: null,
      loading: true,
      error: false
    };
  },
  computed: {
    ...mapGetters('app', ['configData']),
    showPricing() {
      return this.configData && this.configData.show_stats_pricing;
    }
  },
  mounted() {
    this.fetchStats();
    // Обновляем статистику каждые 30 секунд
    this.intervalId = setInterval(this.fetchStats, 30000);
  },
  beforeUnmount() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  },
  methods: {
    async fetchStats() {
      try {
        const response = await axiosConfig.get(API_URL, {
          params: {
            action: 'get_channel_stats',
            channel_id: this.channelId
          }
        });
        
        if (response.data && response.data.stats) {
          this.stats = response.data.stats;
          this.error = false;
        }
      } catch (error) {
        console.error('Ошибка загрузки статистики канала:', error);
        this.error = true;
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style scoped>
.channel-stats-card {
  margin-bottom: 0;
}

.progress-bar {
  transition: width 0.3s ease;
}

.stats-content {
  animation: fadeIn 0.3s ease-in;
}

.stats-list {
  font-size: 0.8rem;
}

.stats-list .py-1 {
  padding-top: 0.15rem !important;
  padding-bottom: 0.15rem !important;
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}
</style>